export default {
  computed: {
    shippingsQuickFiltersCarriers() {
      return {
        title: 'Shippings',
        filters: {
          columns: [
            {
              class: 'col-12',
              filters: [
                {
                  columns: [
                    {
                      class: 'col-12 col-sm-6 col-lg-2',
                      filters: [
                        {
                          name: 'status',
                          label: this.$gettext('Statuses'),
                          type: 'checkbox-group',
                          options: this.$appConfig.validStates.map(x => {
                            return {
                              text: this.$gettext(x),
                              value: x
                            }
                          }),
                          value: [],
                          stacked: true,
                          callback: (val) => {
                            if (val.length > 0) {
                              return [[ 'status', 'in', val ]]
                            } else {
                              return []
                            }
                          }
                        }
                      ]
                    },
                    {
                      class: 'col-12 col-sm-6 col-lg-2',
                      filters: [
                        {
                          name: 'type',
                          label: this.$gettext('Types'),
                          type: 'checkbox-group',
                          options: this.$store.getters.shippingTypes,
                          value: [],
                          stacked: true,
                          callback: (val) => {
                            if (val.length > 0) {
                              return [[ 'shipping_type_id', 'in', val ]]
                            } else {
                              return []
                            }
                          }
                        },
                        {
                          name: 'with-tour',
                          label: this.$gettext('With/without Tour Assigned'),
                          showIf: () => this.ecosystemModules.tours.self || this.ecosystemModules.tours.shared,
                          type: 'radio-group',
                          options: [
                            {
                              text: this.$gettext('Both'),
                              value: null
                            },
                            {
                              text: this.$gettext('With'),
                              value: 1
                            },
                            {
                              text: this.$gettext('Without'),
                              value: 0
                            }
                          ],
                          value: null,
                          stacked: true,
                          callback: (val) => {
                            if (val === 1) {
                              return [['tour_id', 'eq', null, 'true']]
                            } else if (val === 0) {
                              return [['tour_id', 'eq', null]]
                            } else {
                              return []
                            }
                          }
                        }
                      ]
                    },
                    {
                      class: 'col-12 col-lg-4',
                      filters: [
                        {
                          name: 'shipping-id',
                          label: this.$gettext('Shipment ID'),
                          type: 'textarea',
                          value: '',
                          callback: (val) => {
                            if (val.length > 0) {
                              let ids
                              if (val.indexOf('\n') === -1 && val.indexOf(',') === -1 && Array.isArray(val) === false) {
                                return [[ (val.length <= 8) ? 'short_id' : 'id', 'eq', val.trim() ]]
                              } else if (val.indexOf('\n') !== -1) {
                                ids = val.split('\n')
                                return [[ 'id', 'in', ids ]]
                              } else {
                                let ids = val.split(',')
                                return [[ 'id', 'in', ids ]]
                              }
                            } else {
                              return []
                            }
                          }
                        },
                        {
                          name: 'origin-contact-name',
                          label: this.$gettext('Origin Contact Name'),
                          type: 'text',
                          value: '',
                          callback: (val) => {
                            if (val.length > 0) {
                              return [[ 'from_contact', 'ct', val.trim() ]]
                            } else {
                              return []
                            }
                          }
                        },
                        {
                          name: 'shipping-courier',
                          label: this.$gettext('Courier'),
                          type: 'user-autocomplete',
                          restrictToRoles: ['courier'],
                          placeholder: this.$gettext('Courier name or email'),
                          value: [],
                          props: {
                            // endpoint: 'companies/users'
                          },
                          callback: (val) => {
                            if (val.length > 0) {
                              let couriers = val.map(function (item) {
                                return item.id
                              })
                              return [[ 'courier_id', 'in', couriers ]]
                            } else {
                              return []
                            }
                          }
                        },
                        {
                          columns: [
                            {
                              class: 'col-12 col-lg-6',
                              filters: [
                                {
                                  name: 'external-code',
                                  label: this.$gettext('External Code/Order'),
                                  type: 'text',
                                  value: '',
                                  callback: (val) => {
                                    if (val.length > 0) {
                                      return { or: true, filters: [[ 'external_code', 'ct', val.trim() ], [ 'external_order_id', 'ct', val.trim() ]] }
                                    } else {
                                      return []
                                    }
                                  }
                                }
                              ]
                            },
                            {
                              class: 'col-12 col-lg-6',
                              filters: [
                                {
                                  name: 'pickup-shipping',
                                  label: this.$gettext('Pickup Shipping ID'),
                                  type: 'text',
                                  value: '',
                                  callback: (val) => {
                                    if (val.length > 0) {
                                      return {or: true, filters: [[ 'external_order_id', 'eq', val.trim() ], [ 'pickup_shipping_id', 'eq', val.trim() ]]}
                                    } else {
                                      return []
                                    }
                                  }
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    {
                      class: '',
                      filters: [
                        {
                          name: 'destination-contact-name',
                          label: this.$gettext('Destination Contact Name'),
                          type: 'text',
                          value: '',
                          callback: (val) => {
                            if (val.length > 0) {
                              return [[ 'to_contact', 'ct', val.trim() ]]
                            } else {
                              return []
                            }
                          }
                        },
                        {
                          name: 'destination-contact-email',
                          label: this.$gettext('Destination Contact Email'),
                          type: 'text',
                          value: '',
                          callback: (val) => {
                            if (val.length > 0) {
                              return [[ 'to_email', 'ct', val.trim() ]]
                            } else {
                              return []
                            }
                          }
                        },
                        {
                          name: 'destination-address',
                          label: this.$gettext('Destination Address'),
                          type: 'address-autocomplete',
                          staticItems: true,
                          minCharacter: 6,
                          value: {
                            id: null,
                            formatted_address: null
                          },
                          callback: (val) => {
                            if (val.id) {
                              return [[ 'to_place_id', 'eq', val.id ]]
                            } else {
                              return []
                            }
                          }
                        },
                        {
                          name: 'fields-revision',
                          label: this.$gettext('Requires Manual Review'),
                          type: 'checkbox',
                          callback: (val) => {
                            if (val) {
                              return [[ 'fields_revision', 'eq', 1 ]]
                            } else {
                              return []
                            }
                          }
                        },
                        {
                          name: 'shipping-estimated-delivery-date',
                          label: this.$gettext('Est. Delivery Date Range'),
                          type: 'daterange',
                          opens: 'left',
                          value: {
                            startDate: new Date(this.moment().startOf('day').format('YYYY-MM-DD')),
                            endDate: new Date(this.moment().endOf('day').format('YYYY-MM-DD')),
                            dateRangeActive: false
                          },
                          // ranges: {
                          //   [this.$gettext('Today')]: [new Date(this.moment().startOf('day').format('YYYY-MM-DD')), new Date(this.moment().endOf('day').format('YYYY-MM-DD'))],
                          //   [this.$gettext('Yesterday')]: [new Date(this.moment().subtract(1, 'days').startOf('day').format('YYYY-MM-DD')), new Date(this.moment().subtract(1, 'days').endOf('day').format('YYYY-MM-DD'))],
                          //   [this.$gettext('Last 7 days')]: [new Date(this.moment().subtract(6, 'day').startOf('day').format('YYYY-MM-DD')), new Date(this.moment().endOf('day').format('YYYY-MM-DD'))],
                          //   [this.$gettext('Tomorrow')]: [new Date(this.moment().add(1, 'days').startOf('day').format('YYYY-MM-DD')), new Date(this.moment().add(1, 'days').endOf('day').format('YYYY-MM-DD'))],
                          //   [this.$gettext('Next 7 days')]: [new Date(this.moment().startOf('day').format('YYYY-MM-DD')), new Date(this.moment().add(6, 'days').endOf('day').format('YYYY-MM-DD'))]
                          // },
                          callback: (val, filtersState) => {
                            console.log('FILTERS STATE*********', filtersState)

                            if (!filtersState['shipping-id'] && val.dateRangeActive) {
                              const range = [
                                this.moment(val.startDate).tz(this.$tz).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss'),
                                this.moment(val.endDate).tz(this.$tz).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')
                              ]
                              return [[ 'estimated_delivery_date', 'bt', range ]]
                            } else {
                              return []
                            }
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              class: 'col-12',
              filters: [
                {
                  columns: [
                    {
                      class: 'col-12 col-lg-6',
                      filters: [
                        {
                          name: 'shipping-created-at',
                          label: this.$gettext('Created At Date Range'),
                          type: 'daterange',
                          opens: 'right',
                          value: {
                            startDate: this.moment().toDate(),
                            endDate: this.moment().toDate(),
                            dateRangeActive: false
                          },
                          callback: (val, filtersState) => {
                            if (!filtersState['shipping-id'] && val.dateRangeActive) {
                              const range = [
                                this.moment(val.startDate).tz(this.$tz).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss'),
                                this.moment(val.endDate).tz(this.$tz).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')
                              ]
                              return [[ 'created_at', 'bt', range ]]
                            } else {
                              return []
                            }
                          }
                        }
                      ]
                    },
                    {
                      class: 'col-12 col-lg-6',
                      filters: [
                        {
                          name: 'shipping-updated-at',
                          label: this.$gettext('Updated At Date Range'),
                          type: 'daterange',
                          opens: 'left',
                          value: {
                            startDate: this.moment().tz(this.$tz).startOf('day').utc().subtract(14, 'days').toDate(),
                            endDate: this.moment().tz(this.$tz).endOf('day').utc().toDate(),
                            dateRangeActive: true
                          },
                          callback: (val, filtersState) => {
                            if (!filtersState['shipping-id'] && val.dateRangeActive) {
                              const range = [
                                this.moment(val.startDate).tz(this.$tz).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss'),
                                this.moment(val.endDate).tz(this.$tz).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')
                              ]
                              return [[ 'updated_at', 'bt', range ]]
                            } else {
                              return []
                            }
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      }
    }
  }
}
